import { render, staticRenderFns } from "./teacherHome.vue?vue&type=template&id=614355d2&scoped=true&"
import script from "./teacherHome.vue?vue&type=script&lang=js&"
export * from "./teacherHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614355d2",
  null
  
)

export default component.exports